import SwitchUser from './switchuser'

export default SwitchUser